import React from 'react';

export const BuilderWindow = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, setRef: React.Ref<SVGSVGElement>) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="-15 -15 585 440"
        {...props}
      >
        <g>
          <g>
            <g fill="#fff">
              <path d="M-14.9-15h15v439h-15zM554.3-15h15v439h-15z" />
              <path d="M-14.9-15h584.2V0H-14.9zM-14.9 409.1h584.2v15H-14.9z" />
            </g>
          </g>
          <g fill="#e4e4e4" ref={setRef}>
            <path d="M.1 0h10v409H.1zM544.3 0h10v409h-10z" />
            <path d="M.1.1h554.2v10H.1zM.1 399.1h554.2v10H.1z" />
          </g>
          <g>
            <path
              d="M537.3 17v375H17.1V17h520.2m7-7H10.1v389h534.2V10z"
              fill="#4d4d4d"
            />
          </g>
        </g>
      </svg>
    );
  },
);
